import { Modal, ModalContent, ModalHeader, ModalTitle, ModalDescription } from '@klaro7/ui';

import { resolveUploadUrl } from '@/lib/uploads';

import { useCall } from '../context/CallContext';

/**
 * Proposta di rientro in una sessione ancora viva dopo un refresh/crash della
 * pagina: "Hai una sessione attiva con X — Rientra". Visibile solo da idle;
 * se la sessione muore nel frattempo il CallContext azzera resumableSession
 * e il modal sparisce da solo.
 */
export function ResumeSessionModal() {
  const { resumableSession, callState, rejoinSession, declineResume } = useCall();

  if (!resumableSession || callState !== 'idle') return null;

  const isChat = resumableSession.callType === 'chat';

  return (
    <Modal open onOpenChange={() => {}}>
      {/* [&>button]:hidden nasconde la X di chiusura di Radix (unico <button>
          figlio diretto del Content): chiudere qui è ambiguo — la scelta deve
          essere esplicita tra Rientra e Termina sessione. */}
      <ModalContent className="[&>button]:hidden">
        <ModalHeader>
          <ModalTitle>Hai una sessione ancora attiva</ModalTitle>
          <ModalDescription>
            {isChat ? 'La chat' : 'La chiamata'} con {resumableSession.peerName} è ancora in corso
            e il tempo continua a essere addebitato. Vuoi rientrare?
          </ModalDescription>
        </ModalHeader>
        <div className="mt-4 flex items-center gap-3">
          <div className="h-12 w-12 shrink-0 overflow-hidden rounded-full bg-neutral-100">
            {resumableSession.peerAvatar && (
              <img
                src={resolveUploadUrl(resumableSession.peerAvatar)}
                alt=""
                className="h-12 w-12 object-cover"
              />
            )}
          </div>
          <p className="text-sm font-semibold text-neutral-900">{resumableSession.peerName}</p>
        </div>
        <div className="mt-6 flex gap-3">
          <button
            type="button"
            onClick={rejoinSession}
            className="flex-1 rounded-xl bg-brand-orange px-4 py-2.5 text-sm font-semibold text-white transition-colors hover:bg-brand-orange/90"
          >
            Rientra
          </button>
          <button
            type="button"
            onClick={declineResume}
            className="flex-1 rounded-xl border border-neutral-200 bg-white px-4 py-2.5 text-sm font-medium text-neutral-700 transition-colors hover:bg-neutral-50"
          >
            Termina sessione
          </button>
        </div>
      </ModalContent>
    </Modal>
  );
}
